import { useEffect, useState } from "react";

function isStandalone() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}

export default function SplashScreen() {
  const [visible, setVisible] = useState(() => isStandalone() && !sessionStorage.getItem("splash_shown"));
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (!visible) return;
    sessionStorage.setItem("splash_shown", "1");
    const fade = setTimeout(() => setFading(true), 1300);
    const hide = setTimeout(() => setVisible(false), 1750);
    return () => { clearTimeout(fade); clearTimeout(hide); };
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      data-testid="pwa-splash"
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center transition-opacity duration-500 ${fading ? "opacity-0" : "opacity-100"}`}
      style={{ background: "#0A0A0A" }}
    >
      <div className="relative flex flex-col items-center">
        <div className="absolute -inset-10 rounded-full blur-3xl opacity-40" style={{ background: "radial-gradient(circle, #007AFF 0%, transparent 70%)" }} />
        <img src="/logo192.png" alt="SphereHyx" className="relative h-24 w-24 rounded-[22px] border border-white/10 shadow-2xl animate-fade-up" />
        <h1 className="relative mt-6 font-heading font-extrabold text-2xl tracking-tight text-white animate-fade-up">
          Sphere<span style={{ color: "#007AFF" }}>Hyx</span>
        </h1>
        <p className="relative mt-1.5 text-sm text-white/50 animate-fade-up">Connect · Manage · Grow</p>
      </div>
      <div className="absolute bottom-16">
        <div className="h-1 w-24 overflow-hidden rounded-full bg-white/10">
          <div className="h-full w-full origin-left animate-[splash-bar_1.3s_ease-in-out] rounded-full" style={{ background: "linear-gradient(90deg,#007AFF,#10B981)" }} />
        </div>
      </div>
      <style>{`@keyframes splash-bar{0%{transform:scaleX(0)}100%{transform:scaleX(1)}}`}</style>
    </div>
  );
}
